/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_LoadingInputs */

const en_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading...`)
};

const fr_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement...`)
};

const de_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laden...`)
};

const it_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento...`)
};

const ru_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка...`)
};

const es_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando...`)
};

const zh_cn2_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载中...`)
};

const ja_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`読み込み中...`)
};

const hi_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लोड हो रहा है...`)
};

const pt_pt2_knp_terms_loading = /** @type {(inputs: Knp_Terms_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando...`)
};

/**
* | output |
* | --- |
* | "Loading..." |
*
* @param {Knp_Terms_LoadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_loading = /** @type {((inputs?: Knp_Terms_LoadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_LoadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_loading(inputs)
	if (locale === "de") return de_knp_terms_loading(inputs)
	if (locale === "it") return it_knp_terms_loading(inputs)
	if (locale === "ru") return ru_knp_terms_loading(inputs)
	if (locale === "es") return es_knp_terms_loading(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_loading(inputs)
	if (locale === "ja") return ja_knp_terms_loading(inputs)
	if (locale === "hi") return hi_knp_terms_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_loading(inputs)
	return en_knp_terms_loading(inputs)
});